module.exports = __webpack_public_path__ + "img/logo.e36d60b3.svg";